import React from 'react';
import PropTypes from 'prop-types';

const Copy = ({ color = '#647A85', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={31} fill="none" {...props}>
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M9.025 21.491H2.5V3.016h18.475v6.525" />
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M27.5 9.541H9.025v18.475H27.5V9.541Z" />
  </svg>
);
Copy.propTypes = {
  color: PropTypes.string
};

export default Copy;
